import ScriptInjector from "app/utils/ScriptInjector";
import Log from "app/utils/log";
import deadline from "app/utils/deadline";
import Cookies from "app/utils/cookies";
import LoadTimer from "app/utils/load-timer";

const log = new Log("LotameService");
const LOTAME_TIMOUT = 5000; // ms
const LOTAME_ID_COOKIE_NAME = "_cc_id";
const LOTAME_DOMAIN_COOKIE_NAME = "_cc_domain";
const LOTAME_CLIENT_ID = 12097;

class LotameService {
    constructor({ playerHtmlChildId }) {
        this.playerHtmlChildId = playerHtmlChildId;
        this._audience = [];
        this.jsonpCallbackName = "jsonpCallback_" + (Math.floor(Math.random() * 10000) + 2).toString();
        window.bvpLotame = window.bvpLotame || { };
        window.bvpLotame[this.jsonpCallbackName] = this._jsonpCallback.bind(this);
    }

    getSegments() {
        return deadline(LOTAME_TIMOUT, this._loadLotame()).then(() => this._audience)
            .catch(error => {
                log.error("Lotame audience data not available", error);
            });
    }

    _jsonpCallback(data = {}) {
        if (data["Profile"] && data.Profile["Audiences"] && data.Profile.Audiences["Audience"]) {
            this._audience = data.Profile.Audiences.Audience.map(audience => audience.id);
        }
    }

    _loadLotame() {
        log.info("Loading lotame data");
        return ScriptInjector.injectScript(this._getLotameUrl(), document.querySelector("body"), this.playerHtmlChildId, LoadTimer.loadTypes.LOTAME);
    }

    _getLotameUrl() {
        let domain = ".crwdcntrl.net";

        let noDomainCookie = true;
        const domainCookieVal = Cookies.get(LOTAME_DOMAIN_COOKIE_NAME);
        if (domainCookieVal) {
            domain = domainCookieVal;
            noDomainCookie = false;
        }

        let id;
        let idCookie = false;
        if (noDomainCookie) {
            const idCookieVal = Cookies.get(LOTAME_ID_COOKIE_NAME);
            if (idCookieVal) {
                id = idCookieVal;
                idCookie = true;
            }
        }

        let lotameUrl = "//ad" + domain;
        lotameUrl = `${ lotameUrl }/5/c=${ LOTAME_CLIENT_ID }/pe=y/rand=${ (Math.floor(Math.random() * 10000) + 2) }/callback=bvpLotame.${ this.jsonpCallbackName }`;
        if (idCookie) {
            lotameUrl = lotameUrl + "/pid=" + id;
        }

        return lotameUrl;
    }
}

export default LotameService;
